import { API_URL } from "env";

interface ProductCategoryItem {
    id: number;
    name: string;
    slug: string;
    position: number;
    is_active: number | boolean;
    short_content?: string | null;
    avatar?: string | null;
    product_type_id?: number;
    parent_id?: number;
    is_highlight?: number;
    seo_page?: string;
    created_at?: string;
    updated_at?: string;
    translation?: string;
    children?: ProductCategoryItem[];
    // Keeping these if they are used elsewhere in the frontend
    icon?: string;
    alt?: string;
}

async function fetchProductCategoryList(page?: number, limit = 100): Promise<{ status: boolean; data: { total: number; current_page: number; items: ProductCategoryItem[] } }> {
    try {
        const response = await fetch(API_URL + `/api/v1/fe/product_categories?limit=${limit}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to fetch product category list:', error);
        throw error;
    }
}

export {
    fetchProductCategoryList,
}